import { ChangeDetectorRef, Component } from '@angular/core';
import { ReportShareComponent } from '../report-share.component';
import { ReportAssetsRenderedService } from '../report-assets-rendered.service';

@Component({
  selector: 'app-front-page',
  templateUrl: './front-page.component.html'
})
export class FrontPageComponent  extends ReportShareComponent {

  logo: string | null = null;
  front_image: string | null = null;

  constructor(
    private _cdr: ChangeDetectorRef,
    private _report_assets_rendered_service: ReportAssetsRenderedService
  ) {
    super();
  }

  async imageUrlToBase64(url: string): Promise<string> {
    // Resolve against the app's base href, not the current route URL — the report
    // renders at a deep route in the admin app, where a relative "assets/..." would
    // resolve to /assessments/:id/assets/... and 404.
    const data = await fetch(new URL(url, document.baseURI).href);
    const blob = await data.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        const base64data = reader.result;
        resolve(base64data as string);
      };
      reader.onerror = reject;
    });
  };

  ngOnInit() {
    // markForCheck is required: the host may be OnPush (the admin app's report page
    // is), and these assignments land outside any input/event that would mark it.
    const logoLoaded = this.imageUrlToBase64("assets/report-logo.png").then(
      (logo) => {
        this.logo = logo
        this._cdr.markForCheck()
      },
      () => { /* signalled as settled below regardless of outcome */ }
    );

    const frontImageLoaded = this.imageUrlToBase64("assets/report-header.png").then(
      (front_image) => {
        this.front_image = front_image
        this._cdr.markForCheck()
      },
      () => { /* signalled as settled below regardless of outcome */ }
    );

    // Announce readiness once both images have settled — loaded or failed — so a
    // capture (ReportRenderService) waiting on this signal never reads the
    // DOM before these *ngIf-gated <img> elements have had a chance to appear.
    Promise.all([logoLoaded, frontImageLoaded]).then(
      () => this._report_assets_rendered_service.ready()
    );
  }
}
